import Home from '././Home.data-manager-operation-csm.vue'

export default {
  Home
}